import {
  GOLDPRICE_ALL,
  GOLDPRICE_GET,
  GOLDPRICE_DELETE,
  GOLDPRICE_PUT,
  GOLDPRICE_POST,
  GOLDPRICE_LOADING,
  GOLDPRICE_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const goldpriceCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: GOLDPRICE_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/goldprice`,
      {
        ...payload,
      },
    );
    dispatch({ type: GOLDPRICE_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLDPRICE_ERROR });
    throw new Error(error);
  }
};

export const goldpriceAll =
  (params = {}) =>
  async (dispatch) => {
    try {
      const { name = '', size = null, page = 1 } = params;
      const { data, status } = await api.get(
        `${process.env.REACT_APP_API_URL}/goldprice?name=${name}&size=${size}&page=${page}`,
      );
      if (status === 200) {
        dispatch({ type: GOLDPRICE_ALL, payload: data });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: GOLDPRICE_ERROR });
      throw new Error(error);
    }
  };

export const goldpriceGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/goldprice/${id}`,
    );
    if (status === 200) {
      dispatch({ type: GOLDPRICE_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLDPRICE_ERROR });
    throw new Error(error);
  }
};

export const goldpricePut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: GOLDPRICE_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/goldprice/${id}`,
      payload,
    );
    dispatch({ type: GOLDPRICE_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLDPRICE_ERROR });
    throw new Error(error);
  }
};
export const goldpriceDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: GOLDPRICE_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/goldprice/${id}`,
    );
    dispatch({ type: GOLDPRICE_DELETE, payload: data });
  } catch (error) {
    const { status } = error.request;
    console.error(error);

    if (status === 403) {
      const message = 'ไม่สามารถลบข้อมูลเนื่องจากยังคงมีข้อมูลอยู่ในหมวดหมู่';
      dispatch({ type: GOLDPRICE_ERROR, payload: { message } });
      throw new Error(message);
    } else {
      const message = 'เกิดข้อผิดพลาด';
      dispatch({ type: GOLDPRICE_ERROR, payload: { message } });
      throw new Error(message);
    }
  }
};
